import { RegisterOptions, UseFormReturn } from "react-hook-form";
import { getValueByString } from "./Utils";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { useGlobalData } from "../GlobalDataProvider";

interface IProps {
  label: string;
  text: string;
  children?: React.ReactNode;
  multiline?: boolean;
  rows?: number;
  tooltipId?: string;
}

const StaticBox = ({ label, text, multiline, children, rows, tooltipId }: IProps) => {
  const globalData = useGlobalData();

  const renderTooltip = (props: any) => {
    // return <Tooltip {...props}>{"Tooltip for " + label + ":" + globalData.data?.Tooltip.mapTooltip[tooltipId]}</Tooltip>;

    if (tooltipId) return <Tooltip {...props}>{globalData.data?.Tooltip.mapTooltip[tooltipId]}</Tooltip>;
    else return <></>;
  };

  const getTextEditor = () => {
    var htmlPart;

    //Actual input area
    if (multiline) {
      htmlPart = <textarea value={text} id={label} rows={rows} disabled={true} className={"form-control"} />;
    } else {
      htmlPart = (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <input value={text} id={label} type="text" disabled={true} className={"form-control"} />
        </OverlayTrigger>
      );
    }

    //Input group wrapper and validation
    htmlPart = (
      <div className={(children ? "input-group" : "") + " w-100"}>
        {htmlPart}
        {children}
      </div>
    );

    //Label if exists
    if (label) {
      htmlPart = (
        <label className="form-label w-100">
          {label}
          {htmlPart}
        </label>
      );
    }

    htmlPart = <div className="input-group has-validation">{htmlPart}</div>;

    return htmlPart;
  };

  return <>{getTextEditor()}</>;
};

export default StaticBox;
